import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useCallback } from 'react';
import DashboardOverview from '../components/dashboard';
import { useAdminWebSocketStore } from '../stores/websocketStore';
import * as dashboardActions from '../redux/actions/dashboardActions';

const DashboardPageContainer = ({ 
  dashboard, 
  actions,
  userId
}) => {
  const { subscribe, isConnected } = useAdminWebSocketStore();

  // Fetch initial data
  useEffect(() => {
    if (!userId) return;
    actions.fetchDashboardOverview({ userId });
    
    // Set up polling as fallback (every 30 seconds)
    const interval = setInterval(() => {
      actions.fetchDashboardOverview({ userId });
    }, 30000);
    
    return () => clearInterval(interval);
    // The connected container re-binds `actions` on store updates, so keeping it
    // here turns normal dashboard updates into repeated bootstrap fetches.
  }, [userId]);

  // WebSocket-pushed dashboard updates (preferred over polling)
  useEffect(() => {
    const unsubscribe = subscribe(({ message }) => {
      if (!message || !message.messageId) return;

      switch (message.messageId) {
        case 'dashboard-overview-update': {
          if (message.dashboard) {
            actions.setDashboardOverview(message.dashboard);
          }
          break;
        }
        case 'agent-announcement': {
          if (message.agent?.ip) {
            actions.updateAgentStatus(message.agent);
          }
          break;
        }
        default:
          break;
      }
    });

    return unsubscribe;
  }, [subscribe]);
  
  // Manual refresh
  const handleRefresh = useCallback(() => {
    if (!userId) return;
    return actions.fetchDashboardOverview({ userId });
  }, [actions, userId]);
  
  return (
    <DashboardOverview
      dashboard={dashboard}
      loading={dashboard.loading}
      error={dashboard.error}
      onRefresh={handleRefresh}
      realtimeConnected={isConnected}
      userId={userId}
    />
  );
};

const mapStateToProps = (state) => ({
  dashboard: state.dashboard,
  userId: state.catalogReducer?.user?.userId
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(dashboardActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardPageContainer);

